// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bzsfy","col":"styles_col__3aZPf"};